import React, { useState, useEffect } from "react";
import useApiFetcher from "../../hooks/useApiFetcher";
import { FaSearch } from "react-icons/fa";
import LoaderSpiner from "../LoaderSpiner";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const DealsTable = () => {
  const { apiFetcher } = useApiFetcher();
  const delaershipTheme = useTheme();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const dealsPerPage = 5;
  const user = JSON.parse(localStorage.getItem("user"));

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const [custs, setCusts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  async function fetchDeals() {
    try {
      const response = await apiFetcher(
        `/deals/${user?.dealershipId?._id}`,
        "GET"
      );
      setCusts(response);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching deals:", error.message);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    fetchDeals();
  }, []);

  const [deployedDeals, setDeployedDeals] = useState([]);
  const handleDeployClick = async (dealId, custId, custEmail, dealershipName) => {
    if (!deployedDeals.includes(dealId)) {
      setDeployedDeals((prev) => [...prev, dealId]);
      const url = generateUrl(dealId, custId);
      try {
        await apiFetcher("/multi-stepper/send-deploy-email", "POST", {
          recipientEmail: custEmail,
          url: url,
          dealershipName: dealershipName || user?.dealershipId?.dealershipName
        });
      } catch (error) {
        console.error("Error sending deploy email:", error.message);
      }
    }
  };

  const generateUrl = (dealId, custId) => {
    return `https://admin.provaantech.com/board/?deal=${dealId}&custId=${custId}`;
  };

  // Pagination Logic
  const filteredDeals = custs.filter((deal) =>
    deal?.custId?.customerName
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase())
  );
  const indexOfLastDeal = currentPage * dealsPerPage;
  const indexOfFirstDeal = indexOfLastDeal - dealsPerPage;
  const currentDeals = filteredDeals.slice(indexOfFirstDeal, indexOfLastDeal);

  const totalPages = Math.ceil(filteredDeals.length / dealsPerPage) || 1;
  const themeColor = user?.role === "DealershipAdmin" ? delaershipTheme : "#3b82f6";

  return (
    <div className="glass-panel w-full flex flex-col p-6 animate-fade-in-up mt-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h2 className="text-2xl font-bold text-white">List of Deals</h2>

        <div className="relative w-full md:w-auto">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-600">
            <FaSearch />
          </div>
          <input
            type="text"
            placeholder="Search by customer name..."
            className="input-field pl-10 w-full md:w-80"
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="w-full overflow-x-auto rounded-lg border border-blue-200/50 scrollbar-hide">
        {isLoading ? (
          <div className="flex justify-center items-center py-20">
            <LoaderSpiner />
          </div>
        ) : (
          <table className="w-full text-left border-collapse min-w-max">
            <thead>
              <tr className="text-white text-sm font-semibold whitespace-nowrap" style={{ backgroundColor: themeColor }}>
                <th className="px-4 py-4 rounded-tl-lg">No</th>
                <th className="px-4 py-4">Customer Name</th>
                <th className="px-4 py-4">Email</th>
                <th className="px-4 py-4">Phone No</th>
                <th className="px-4 py-4">Address</th>
                <th className="px-4 py-4">Vehicle</th>
                <th className="px-4 py-4">Downpayment</th>
                <th className="px-4 py-4">Lender</th>
                <th className="px-4 py-4">Finance Terms</th>
                <th className="px-4 py-4">Sales Price</th>
                <th className="px-4 py-4">Created At</th>
                <th className="px-4 py-4">Progress</th>
                <th className="px-4 py-4 rounded-tr-lg">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/50 bg-white/30">
              {currentDeals.length > 0 ? currentDeals.map((deal, index) => (
                <tr key={deal.custId?.["$oid"] || index} className="text-slate-700 text-sm hover:bg-white/5 transition-colors group">
                  <td className="px-4 py-4">{indexOfFirstDeal + index + 1}</td>
                  <td className="px-4 py-4 font-medium">{deal?.custId?.customerName}</td>
                  <td className="px-4 py-4">{deal?.custId?.email}</td>
                  <td className="px-4 py-4">{deal?.custId?.phoneNumber}</td>
                  <td className="px-4 py-4 max-w-[200px] truncate">{deal?.custId?.address}</td>
                  <td className="px-4 py-4">{deal?.carId?.carName}</td>
                  <td className="px-4 py-4 text-green-400 font-medium">${deal?.downpayment?.replace('$', '')}</td>
                  <td className="px-4 py-4">{deal?.lender}</td>
                  <td className="px-4 py-4">${deal?.financeAmount?.replace('$', '')}</td>
                  <td className="px-4 py-4 font-medium text-primary-400">${deal?.salesPrice?.replace('$', '')}</td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    {`${new Date(deal.createdAt).toLocaleString("default", { month: "long" })} ${new Date(deal?.createdAt).getDate()}, ${new Date(deal?.createdAt).getFullYear()}`}
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex flex-row items-center justify-center gap-2 ">
                      <span className="text-xs font-medium px-2 py-1 bg-blue-100 rounded-md text-slate-700 w-fit">
                        {deal?.custId?.completedRounds ? `Completed Rounds: ${deal?.custId?.completedRounds}` : "Rounds: N/A"}
                      </span>
                      {deal?.custId?.currentStep && (
                        <span className="text-xs font-medium px-2 py-1 bg-blue-100 rounded-md text-slate-700 w-fit">
                          Step: {deal?.custId?.currentStep}
                        </span>
                      )}
                      {deal?.custId?.completedRounds === 2 && (
                        <button
                          className="text-xs bg-accent-600 hover:bg-accent-500 text-white font-semibold py-1.5 px-3 rounded shadow-md mt-2 transition-colors active:scale-95"
                          onClick={async () => {
                            await apiFetcher(`/track-progress`, "PUT", { userId: deal?.custId?._id, deal: deal?._id });
                            fetchDeals();
                          }}
                        >
                          Active Link
                        </button>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    {user?.multiStepProcessId ? (
                      <div>
                        {deployedDeals.includes(deal?._id) ? (
                          <a
                            href={generateUrl(deal?._id, deal?.custId?._id)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs font-medium text-primary-400 hover:text-primary-300 underline break-all max-w-[150px] inline-block"
                          >
                            {generateUrl(deal?._id, deal?.custId?._id)}
                          </a>
                        ) : (
                          <button
                            className="text-xs text-white font-semibold py-2 px-3 rounded shadow-lg transition-transform active:scale-95 hover:opacity-90"
                            style={{ backgroundColor: themeColor }}
                            onClick={() => handleDeployClick(deal?._id, deal?.custId?._id, deal?.custId?.email, deal?.dealershipId?.dealershipName)}
                          >
                            Deploy Avatar
                          </button>
                        )}
                      </div>
                    ) : (
                      <span className="text-xs text-slate-500 italic">Not Available</span>
                    )}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="13" className="px-4 py-12 text-center text-slate-500">
                    No deals found matching your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {!isLoading && totalPages > 1 && (
        <div className="flex justify-center items-center mt-6 gap-2">
          <button
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className="px-4 py-2 rounded-lg font-medium text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-white text-slate-700 hover:bg-blue-100"
          >
            Prev
          </button>

          <div className="flex gap-1">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                className={`w-10 h-10 rounded-lg flex items-center justify-center font-medium text-sm transition-all ${currentPage === index + 1
                  ? 'text-white shadow-lg scale-105'
                  : 'bg-white text-slate-600 hover:bg-blue-100 hover:text-white'
                  }`}
                style={currentPage === index + 1 ? { backgroundColor: themeColor } : {}}
              >
                {index + 1}
              </button>
            ))}
          </div>

          <button
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
            className="px-4 py-2 rounded-lg font-medium text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-white text-slate-700 hover:bg-blue-100"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default DealsTable;
